import { Button, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import {
  DeleteOutlined,
  EditOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { deleteInvoice } from './deleteInvoice';

/**
 * Creates edit and archive buttons for invoice show pages.
 * This eliminates code duplication between customer and intern invoice show pages.
 * @function
 * @param {Object} params - Configuration parameters
 * @param {Function} params.t - Translation function
 * @param {string} params.id - Invoice ID
 * @param {string} params.editPath - Path for the edit link
 * @param {Function} params.dispatchAPI - API dispatch function
 * @param {Function} params.message - Error message function
 * @param {string} params.invoicePath - Path for deleteInvoice (e.g., 'customerinvoices' or 'interninvoices')
 * @param {Function} params.navigate - Navigation function
 * @returns {JSX.Element} Edit and archive buttons
 */
export const createEditArchiveButtons = ({
  t,
  id,
  editPath,
  dispatchAPI,
  message,
  invoicePath,
  navigate
}) => (
  <>
    <Link
      to={{
        pathname: editPath
      }}
    >
      <Button type="primary">
        {`${t('buttons.edit')} `}
        <EditOutlined />
      </Button>
    </Link>
    <Popconfirm
      title={t('datatable.column.action.archive.title')}
      okText={t('datatable.column.action.archive.ok')}
      okButtonProps={{ type: 'danger' }}
      cancelText={t('datatable.column.action.archive.cancel')}
      onConfirm={() =>
        deleteInvoice({
          id,
          dispatchAPI,
          message,
          path: invoicePath,
          navigate
        })
      }
      icon={<WarningOutlined />}
    >
      <Button type="link" danger>
        {`${t('buttons.archive')} `}
        <DeleteOutlined />
      </Button>
    </Popconfirm>
  </>
);
